'use strict';

const React = require( 'react' );
const getAirportInfo = require( '../getAirportInfo' );
const propTypes = require('prop-types');
const SchemaTag = require( '../SchemaTag.jsx' );
const { object, string, bool } = propTypes;
const createReactClass = require('create-react-class');

const ReviewsMeta = createReactClass({
  propTypes: {
    id: string.isRequired,
    pageData: object.isRequired,
    noSchemaMarkup: bool
  },

  getDefaultProps( ) {
    return {
      noSchemaMarkup: false
    };
  },

  getDataFromFeed( ) {
    const feed = this.getFeedPath( );
    try {
      const locationData = require( '../../../../../config/exports/reviews/' + feed + '.json' );
      return locationData.meta;
    } catch (e) {
      return false;
    }
  },

  getFeedPath( ) {
    const { pageData } = this.props;
    const airport = getAirportInfo( pageData.pageName );
    let path = '';
    switch ( pageData.productClass.toUpperCase( ) ) {
    case 'CP':
      if ( !airport ) {
        path = 'parkingReviewsMeta';
        break;
      }
      path = 'parking/meta/' + airport.code;
      break;
    case 'HCP':
    case 'HO':
      if ( !airport ) {
        path = 'hotelReviewsMeta';
        break;
      }
      path = 'hotels/meta/' + airport.code;
      break;
    }

    return path;
  },

  render( ) {
    const { id, noSchemaMarkup } = this.props;
    const feedData = this.getDataFromFeed( );
    if ( !feedData || !feedData.averageAsPercentage ) return ( <span id={ id } /> );
    const reviewCount = feedData.count.toLocaleString( );

    return (
      <SchemaTag tagType="div" noSchemaMarkup={ noSchemaMarkup } id={ id } itemScope itemType="http://schema.org/Product">
        <ul className="infostat unstyled">
          <li><span className="priceSmall">{ feedData.averageAsPercentage }%</span> of customers who left a review would book again.</li>
          <li>
            <SchemaTag tagType="span" noSchemaMarkup={ noSchemaMarkup } className="priceSmall" itemProp="name">Airport parking</SchemaTag>
            <SchemaTag tagType="span" noSchemaMarkup={ noSchemaMarkup } itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating"> is rated, on average, <SchemaTag tagType="span" noSchemaMarkup={ noSchemaMarkup } className="priceSmall" itemProp="ratingValue">{ feedData.averageAsInteger }</SchemaTag> out of <SchemaTag tagType="span" noSchemaMarkup={ noSchemaMarkup } className="priceSmall" itemProp="bestRating">5</SchemaTag><SchemaTag tagType="meta" noSchemaMarkup={ noSchemaMarkup } itemProp="worstRating" content="0" /> by <SchemaTag tagType="span" noSchemaMarkup={ noSchemaMarkup } className="priceSmall" itemProp="ratingCount">{ reviewCount }</SchemaTag> Airparks customers.
            </SchemaTag>
          </li>
        </ul>
      </SchemaTag>
    );
  }
});

module.exports = ReviewsMeta;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/reviews-meta.jsx